import { Component, OnInit, Input, AfterViewInit } from "@angular/core";
import { StateService } from "src/app/services/state.service";
import { environment } from "../../../../environments/environment";
// declare var jwplayer: any;
declare var flvjs: any;

@Component({
  selector: "app-videojs",
  templateUrl: "./videojs.component.html",
  styleUrls: ["./videojs.component.css"],
})
export class VideojsComponent implements OnInit, AfterViewInit {
  @Input() id: number;
  url;
  constructor(public _state: StateService) { }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.url = environment.stream_url + this._state.username + "_" + this.id + ".flv";
    console.log(this.url);
    if (flvjs.isSupported()) {
      const videoElement = document.getElementById('videoElement' + this.id);
      const flvPlayer = flvjs.createPlayer({
        type: 'flv',
        url: this.url
      });
      flvPlayer.attachMediaElement(videoElement);
      flvPlayer.load();
      flvPlayer.play();
    }
    // jwplayer("mediaspace" + this.id).setup({
    //   flashplayer: "assets/jwplayer/jwplayer.flash.swf",
    //   file: this.url,
    //   autostart: "true",
    //   primary: "flash",
    //   width: "100%",
    // });
  }
}
